import { defaultFdsEmpresa, defaultFdsEmpresaParametros } from './state';

// Generales
/**
 * Mutación para parametrizar acción del formulario.
 * @param state
 * @param accion
 */
export function setAccion(state, accion) {
  state.accion = accion;
}

/**
 * Mutación para parametrizar el id de la empresa.
 * @param state
 * @param id_empresa
 */
export function setIdEmpresa(state, id_empresa) {
  state.id_empresa = id_empresa;
}

// Mutations FdsDatosEmpresa
/**
 * Mutación para parametrizar datos de empresa.
 * @param state
 * @param data
 */
export function setDatosFdsEmpresa(state, data) {
  state.selectedFdsEmpresa = data;
}

/**
 * Mutación para parametrizar datos de empresa general.
 * @param state
 * @param data
 */
export function setDatosEmpresaGeneral(state, data) {
  let datosEmpresaGeneral = {
    id_empresa: data.id,
    nombre_empresa: data.nombre,
    nit: data.nit,
    telefono: data.telefono,
    telefono_emergencia: '',
    direccion: data.direccion,
    datos_adicionales: '',
  }
  Object.assign(state.selectedFdsEmpresa, datosEmpresaGeneral);
}

/**
 * Mutación para reiniciar empresa.
 * @param state
 */
export function resetSelectedFdsEmpresa(state) {
  Object.assign(state.selectedFdsEmpresa, defaultFdsEmpresa());
}

/**
 * Mutación para mostrar errores.
 * @param state
 */
export function empresaDatosError(state) {
  console.log('empresaDatosError');
}

// Mutations FdsEmpresaParametros
/**
 * Mutación para obtener el listado de parámetros para el formulario.
 * @param state
 * @param data
 */
export function setFdsListasParametros(state, data) {
  state.fdsListasParametros = data;
}

/**
 * Mutación para parametrizar listado de parámetros.
 * @param state
 * @param data
 */
export function setFdsEmpresaParametros(state, data) {
  state.selectedFdsEmpresaParametros = data;
}

/**
 * Mutación para reinciar parámetros de empresa.
 * @param state
 */
export function resetSelectedFdsEmpresaParametros(state) {
  Object.assign(state.selectedFdsEmpresaParametros, defaultFdsEmpresaParametros());
}

/**
 * Mutación para presentar error.
 * @param state
 */
export function empresaParametrosError(state) {
  console.log('empresaParametrosError');
}
